module.exports = __webpack_public_path__ + "img/icon-btn-ios2.fc1faf8d.png";